<template>
  <span>
    <a class="btn btn-primary btn-sm btn-link" title="Add new Agreement" id="show-agreeement-modal" @click="showAgreementModal = true"><i class="fa fa-plus-square"></i></a>
    <!-- use the modal component, pass in the prop -->
    <add-agreement-modal v-bind:record="record" v-if="showAgreementModal" @close="showAgreementModal = false">
      <!--
        you can use custom content here to overwrite
        default content
      -->
    </add-agreement-modal>
  </span>
</template>

<script>
import AddAgreementModal from "./AddAgreementModal";

export default {
  name: "add-agreement-button",
  props: ["record"],
  components: { AddAgreementModal },
  data: function() {
    return {
      showAgreementModal: false
    };
  }
};
</script>
